export function stringTruncateFromLeft(
    str: string | undefined
) {
    if (str === undefined) {
        return '-'
    }
    const midChar = '…'
    let left, right
    // eslint-disable-next-line prefer-const
    left = Math.ceil(6)
    // eslint-disable-next-line prefer-const
    right = str.length - Math.floor(3)
    return str.substring(0, left) + midChar + str.substring(right)
}
